import React from 'react';
import { TOTAL_SCREENS } from '../utilities/commonUtils';

function KonstaltingContainer() {

    const mapAllScreens = () => {
        return (
            TOTAL_SCREENS.map((screen) => 
            (screen.componnent) ? <screen.componnent screenName={screen.screen_name}key={screen.screen_name}
            id={screen.screen_name}/> : <div key={screen.screen_name}></div>
            )
        )
    }

    return (
        <div className='konstalting-container'> {/* pazi da promjeniš ovo u cssu gdje god 
        bilo jer je stajalo portfolio, mada izgleda da nema nigdje*/}
            {mapAllScreens()}
        </div>
    );
}

export default KonstaltingContainer;